import React from 'react';
import classNames from 'clsx';
import { useApplicationParams } from '../../context';

const WebContainer = ({ children }) => {
  const { isWeb } = useApplicationParams();

  const containerClassName = classNames({
    'page-section-web': isWeb,
  });

  return <div className={containerClassName}>{children}</div>;
};

export default WebContainer;
